import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatSupabaseError } from "../lib/supabase";

export const SettingsTab = () => {
  const { user, logout, changePassword } = useAuth();
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw.length < 8) {
      toast.error("Neues Passwort muss mindestens 8 Zeichen haben.");
      return;
    }
    if (newPw !== confirmPw) {
      toast.error("Neue Passwörter stimmen nicht überein.");
      return;
    }
    setLoading(true);
    try {
      await changePassword(newPw);
      toast.success("Passwort geändert. Bitte neu einloggen.");
      setNewPw("");
      setConfirmPw("");
      setTimeout(() => logout(), 1500);
    } catch (err) {
      toast.error(formatSupabaseError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="flex items-center gap-3 text-[11px] tracking-[0.4em] uppercase text-zinc-500 font-semibold mb-4">
        <span className="red-led" /> Einstellungen
      </div>
      <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-4xl md:text-5xl mb-10">Zugang</h2>

      <div className="mb-10 bg-[#0A0A0A] border border-white/[0.06] p-6">
        <div className="text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-3">Eingeloggt als</div>
        <div className="font-display font-bold text-xl">{user?.email}</div>
        <div className="text-xs text-zinc-500 mt-1">User-ID: {user?.id?.slice(0, 8)}…</div>
      </div>

      <form onSubmit={submit} noValidate className="bg-[#0A0A0A] border border-white/[0.06] p-6 md:p-8">
        <div className="flex items-center gap-3 mb-6">
          <KeyRound size={16} className="text-[#ff0033]" />
          <h3 className="font-display font-black uppercase tracking-tight text-xl">Passwort ändern</h3>
        </div>
        <Field label="Neues Passwort (min. 8 Zeichen)" type="password" value={newPw} onChange={setNewPw} testid="settings-new-pw" />
        <Field label="Neues Passwort bestätigen" type="password" value={confirmPw} onChange={setConfirmPw} testid="settings-confirm-pw" />
        <button type="submit" disabled={loading} data-testid="settings-change-submit" className="group mt-4 inline-flex items-center gap-3 bg-white text-black px-6 py-3 text-[11px] font-bold tracking-[0.3em] uppercase overflow-hidden relative disabled:opacity-50 hover:shadow-[0_0_24px_rgba(255,0,51,0.35)] transition-shadow">
          <span className="relative z-10 group-hover:text-white transition-colors">{loading ? "Speichere…" : "Passwort ändern"}</span>
          <span className="absolute inset-0 bg-[#ff0033] translate-y-full group-hover:translate-y-0 transition-transform duration-500" />
        </button>
      </form>
    </div>
  );
};

const Field = ({ label, value, onChange, type = "text", testid }) => (
  <label className="block mb-4">
    <span className="block text-[10px] tracking-[0.3em] uppercase text-zinc-500 font-bold mb-2">{label}</span>
    <input type={type} value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid} className="w-full bg-[#050505] border border-white/10 focus:border-[#ff0033]/60 outline-none text-white text-sm p-3 font-medium transition-colors" />
  </label>
);
